<template>
    <div>
        <Head />
        <Login v-if="isLogin" @LoginOpen="openL" />
        <div class="changpswd">
            <div class="rNav">
                <div :class="{ active: nav == 0 }" @click="rNav(0)">企业(单位)密码找回</div>
                <div :class="{ active: nav == 1 }" @click="rNav(1)">个人密码找回</div>
            </div>
            <div class="rMain" v-show="nav == 0">
                <div>
                    <span>手机号码：</span>
                    <div><input type="text" v-model="company.Phone" placeholder="请输入您的注册手机号" />*</div>
                </div>
                <div>
                    <span style="margin-left:.2rem">验证码：</span>
                    <div>
                        <input type="text" v-model="company.yzm" style="width:2.5rem" placeholder="请输入验证码" />
                        <button
                            :class="btnDisabled ? 'btn2' : 'btn'"
                            style="margin:0 .2rem 0 .5rem"
                            @click="sendMessage()"
                            :disabled="btnDisabled"
                        >
                            {{ btnText }}</button
                        >*
                    </div>
                </div>
                <div>
                    <span style="margin-left:.2rem">新密码：</span>
                    <div><input type="password" v-model="company.password1" placeholder="请输入您的密码" />*</div>
                </div>
                <div>
                    <span>确认密码：</span>
                    <div><input type="password" v-model="company.password2" placeholder="请再次输入您的密码" />*</div>
                    <!-- <p class="verify" v-if="!(userMsg.Pwd===userMsg.Pwd1)">两次输入密码不一致</p> -->
                </div>
                <div class="fBtn">
                    <el-button style="width:3.5rem;height:.6rem;background: #d8710d;color:#fff" @click="change(0)"
                        >修改</el-button
                    >
                    <!-- <div class="btn" @click="addUser">注册</div>
        
          <div class="btn btn1" @click="openLogin">登录</div>-->
                    <el-button type="primary" style="width:3.5rem;height:.6rem;color:#fff" @click="openLogin"
                        >登录</el-button
                    >
                </div>
            </div>
            <div class="rMain" v-show="nav == 1">
                <div>
                    <span>手机号码：</span>
                    <div><input v-model="user.Phone" type="text" placeholder="请输入您的注册手机号" />*</div>
                </div>
                <div>
                    <span style="margin-left:.2rem">验证码：</span>
                    <div>
                        <input type="text" v-model="user.yzm" style="width:2.5rem" placeholder="请输入验证码" />
                        <button
                            :class="btnDisabled1 ? 'btn2' : 'btn'"
                            style="margin:0 .2rem 0 .5rem;"
                            @click="sendMessage1()"
                            :disabled="btnDisabled1"
                        >
                            {{ btnText1 }}</button
                        >*
                    </div>
                </div>
                <div>
                    <span style="margin-left:.2rem">新密码：</span>
                    <div><input type="password" v-model="user.password1" placeholder="请输入您的密码" />*</div>
                </div>
                <div>
                    <span>确认密码：</span>
                    <div><input type="password" v-model="user.password2" placeholder="请再次输入您的密码" />*</div>
                    <!-- <p class="verify" v-if="!(userMsg.Pwd===userMsg.Pwd1)">两次输入密码不一致</p> -->
                </div>
                <div class="fBtn">
                    <el-button style="width:3.5rem;height:.6rem;background: #d8710d;color:#fff" @click="change"
                        >修改</el-button
                    >
                    <!-- <div class="btn" @click="addUser">注册</div>
        
          <div class="btn btn1" @click="openLogin">登录</div>-->
                    <el-button type="primary" style="width:3.5rem;height:.6rem;color:#fff" @click="openLogin"
                        >登录</el-button
                    >
                </div>
            </div>
        </div>
        <Foot />
    </div>
</template>

<script>
import Head from "../components/Head";
import Foot from "../components/Foot";
import Login from "../components/Login";
export default {
    data() {
        return {
            nav: 0,
            btnText: "获取短信验证码",
            btnText1: "获取短信验证码",
            btnDisabled: false,
            btnDisabled1: false,
            isLogin: false,
            company: {
                Phone: "",
                yzm: "",
                source: "company",
                password1: "",
                password2: "",
            },
            user: {
                Phone: "",
                yzm: "",
                source: "user",
                password1: "",
                password2: "",
            },
        };
    },
    methods: {
        rNav(i) {
            this.nav = i;
        },
        openL(e) {
            this.isLogin = e;
        },
        openLogin() {
            this.isLogin = true;
        },
        change(i) {
            const regex = /^.*(?=.{8,16})(?=.*\d)(?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*[!@#$%_^&*.?\\(\\)])(?!.*?[^\S*]).*$/;
            if (i == 0) {
                if (!regex.test(this.company.password1)) {
                    this.$message({
                        message:
                            "密码要求：长度为8-16个字符，必须包含大小写字母、数字、特殊符号（!@#$%_^&*.?不包括空格）",
                        type: "warning",
                    });
                    return;
                }
            } else {
                if (!regex.test(this.user.password1)) {
                    this.$message({
                        message:
                            "密码要求：长度为8-16个字符，必须包含大小写字母、数字、特殊符号（!@#$%_^&*.?不包括空格）",
                        type: "warning",
                    });
                    return;
                }
            }

            let that = this;
            this.$confirm("确认修改密码, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                if (i == 0) {
                    that.$axios.post("welcome/telresetpwd", that.$qs.stringify(that.company)).then((res) => {
                        if (res.data.code == 10000) {
                            that.$message({
                                message: res.data.msg,
                                type: "success",
                            });
                            // that.$router.replace("/");
                            for (var key in that.company) {
                                if (key != "source") {
                                    that.company[key] = "";
                                }
                            }
                            that.isLogin = true;
                        } else {
                            that.$message({
                                message: res.data.msg,
                                type: "info",
                            });
                        }
                    });
                } else {
                    that.$axios.post("welcome/telresetpwd", that.$qs.stringify(that.user)).then((res) => {
                        if (res.data.code == 10000) {
                            that.$message({
                                message: res.data.msg,
                                type: "success",
                            });
                            //  that.$router.replace("/");
                            for (var key in that.user) {
                                if (key != "source") {
                                    that.user[key] = "";
                                }
                            }
                            that.isLogin = true;
                            // location.reload();
                        } else {
                            that.$message({
                                message: res.data.msg,
                                type: "info",
                            });
                        }
                    });
                }
            });
        },
        sendMessage() {
            let that = this;
            if (this.btnDisabled) {
                return;
            }
            if (!that.company.Phone) {
                that.$message.error("手机号不能为空");
                return;
            } else {
                this.$axios
                    .post(
                        "sendmsg/send",
                        that.$qs.stringify({
                            Phone: that.company.Phone,
                            actions: "MsgRetPwd",
                        })
                    )
                    .then((res) => {
                        if (res.data.code == 10000) {
                            that.$message({
                                message: "短信验证码已发送,请注意查收",
                                type: "success",
                            });
                        } else {
                            that.$message(res.data.msg);
                        }
                    });
            }
            this.getSecond(120);
        },
        //发送验证码
        getSecond(wait) {
            let _this = this;
            let _wait = wait;
            if (wait == 0) {
                this.btnDisabled = false;
                this.btnText = "获取短信验证码";
                wait = _wait;
            } else {
                this.btnDisabled = true;
                this.btnText = "验证码(" + wait + "s)";
                wait--;
                setTimeout(function() {
                    _this.getSecond(wait);
                }, 1000);
            }
        },
        sendMessage1() {
            let that = this;
            if (!that.user.Phone) {
                that.$message.error("手机号不能为空");
                return;
            } else {
                this.$axios
                    .post(
                        "sendmsg/send",
                        that.$qs.stringify({
                            Phone: that.user.Phone,
                            actions: "MsgRetPwd",
                        })
                    )
                    .then((res) => {
                        if (res.data.code == 10000) {
                            that.$message({
                                message: "短信验证码已发送,请注意查收",
                                type: "success",
                            });
                        } else {
                            that.$message(res.data.msg);
                        }
                    });
            }
            if (this.btnDisabled1) {
                return;
            }
            this.getSecond1(120);
        },
        getSecond1(wait) {
            let _this = this;
            let _wait = wait;

            if (wait == 0) {
                this.btnDisabled1 = false;
                this.btnText1 = "获取短信验证码";
                wait = _wait;
            } else {
                this.btnDisabled1 = true;
                this.btnText1 = "验证码(" + wait + "s)";
                wait--;
                setTimeout(function() {
                    _this.getSecond1(wait);
                }, 1000);
            }
        },
    },
    components: {
        Head,
        Foot,
        Login,
    },
};
</script>

<style lang="less" scoped>
.changpswd {
    .fBtn {
        width: 100%;
        margin: 0.5rem auto;
    }
    .btn {
        border: 0;
        outline: none;
        width: 1.7rem;
        height: 0.45rem;
        // padding: 0.1rem 0.3rem;
        background: #3694e6;
        color: white;
        border-radius: 0.05rem;
        cursor: pointer;
        margin-right: 0.2rem;
        border: 0;
    }
    .btn2 {
        // width: 2rem;
        width: 1.7rem;
        height: 0.45rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        font-size: 0.15rem;
        border: 1px solid #ccc;
        border-radius: 0.05rem;
        margin-right: 0.2rem;
        // border: 0;
    }
    width: 100%;
    min-width: 1000px;
    padding: 0 1.35rem;
    margin-top: 0.5rem;
    .rNav {
        width: 100%;
        display: flex;
        border-bottom: 0.01rem solid #c9c9c9;
        > div {
            border: 0.01rem solid #c9c9c9;
            border-bottom: 0;
            font-size: 0.2rem;
            padding: 0.15rem 0.3rem;
            cursor: pointer;
            &.active {
                color: white;
                background: #3694e6;
                border: 0;
            }
        }
    }
    .rMain {
        font-size: 0.2rem;
        margin-top: 0.5rem;
        > div {
            width: 9rem;
            display: flex;
            align-items: center;
            padding: 0.15rem 0;

            &.radio {
                align-items: flex-start;
                div {
                    display: flex;
                    font-size: 0.14rem;
                    flex-wrap: wrap;
                    align-items: center;
                    label {
                        display: flex;
                        flex-shrink: 0;
                        align-items: center;
                        color: black;
                        margin-right: 0.19rem;
                        bottom: 0.05rem;
                        input {
                            width: 0.15rem;
                            height: 0.15rem;
                            margin-right: 0.05rem;
                        }
                    }
                    span {
                        margin-left: 0.1rem;
                    }
                }
            }
            &.textarea {
                align-items: flex-start;
                div {
                    align-items: flex-start;
                    justify-content: space-between;
                    textarea {
                        width: 4rem;
                        height: 1.5rem;
                        resize: none;
                        padding: 0.1rem 0.2rem;
                    }
                    .imgUp {
                        padding: 0.1rem 0.3rem;
                        background: #3694e6;
                        color: white;
                        border-radius: 0.05rem;
                        cursor: pointer;
                    }
                }
            }
            &.fBtn {
                display: flex;
                margin: 1rem auto 0;
                justify-content: space-between;
                .btn {
                    width: 3.5rem;
                    height: 0.6rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: #d8710d;
                    color: #fff;
                    border-radius: 0.05rem;
                    margin-bottom: 0.1rem;
                }
                .btn:nth-of-type(2) {
                    background: #3694e6;
                }
                .btn1 {
                    background-color: #3694e6;
                }
                .text {
                    font-size: 0.14rem;
                    color: #b8b8b8;
                    span {
                        color: #3694e6;
                        cursor: pointer;
                    }
                }
            }
            > span.firmSpan {
                display: inline-block;
                width: 1.3rem;
                text-align: right;
            }
            > span {
                color: #505050;
                flex-shrink: 0;
                margin-right: 0.4rem;
                span {
                    display: inline-block;
                    width: 0.35rem;
                }
                display: inline-block;
            }
            select,
            input {
                height: 0.4rem;
                // width: 2.5;
                margin-right: 0.2rem;
                font-size: 0.18rem;
                padding-right: 0.2rem;
            }
            input {
                padding-left: 0.2rem;
                height: 0.4rem;
                width: 4.9rem;
            }
            select {
                min-width: 2.5rem;
                // color: #757575;

                option {
                    color: #000;
                }
                &.active {
                    color: #000;
                }
            }
            > div {
                display: flex;
                align-items: center;
                color: red;
                position: relative;

                > .el-cascader {
                    position: absolute;
                    opacity: 0;
                }
                > div {
                    flex-shrink: 0;
                    display: flex;
                    // width: 6rem;
                    align-items: center;
                    // margin-right: 0.1rem;

                    .btn {
                        width: 2rem;
                        height: 0.45rem;
                        // margin-left: 0.3rem;
                        // border: 0.01rem solid #bdbdbd;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        // color: #b8b8b8;
                        font-size: 0.15rem;
                        cursor: pointer;
                        border: 0;
                    }
                }
            }
        }
    }
}
</style>
